module.exports = __webpack_public_path__ + "img/97.059e69ba.jpg";